module.exports = __webpack_public_path__ + "img/avatar7.9611b8cf.png";